import { useQuery } from '@tanstack/react-query';
import { getExcludedTeeth, type ExcludedTeethMap } from '../services/dmMonitoringControl';

export function dmExcludedTeethKey(patientId: string | undefined) {
    return ['v2/patients', patientId, 'dm', 'excluded-teeth'] as const;
}

export function useDmExcludedTeeth(patientId: string | undefined, enabled = true) {
    const { data, error, isLoading, refetch } = useQuery<ExcludedTeethMap>({
        queryKey: dmExcludedTeethKey(patientId),
        queryFn: () => getExcludedTeeth(patientId!),
        enabled: !!patientId && enabled,
        staleTime: 2 * 60 * 1000
    });

    return { data: data ?? null, isLoading, error, refetch };
}
